<template>
  <failed-physical-location-activity-verification />
</template>

<script>
import FailedPhysicalLocationActivityVerification from '@/components/holding-tanks/FailedPhysicalLocationActivityVerification.vue';

export default {
  name: 'VerifyPhysicalAssetsWrapper',
  components: {
    FailedPhysicalLocationActivityVerification,
  },
};
</script>
